import { IFilterLibelle } from '../../../../../core/filters/ex-libelle.filter';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireTemplateSlotClass } from '../../../../../core/services/formulaire/formulaire-template-slot.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuItemMultiOccurrenceClass } from '../../../../../core/services/menu/menu-item-multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageGS2006 {
    rqcMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rqaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    ragMultiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
    formulaireGs: any;
}
/* @ngInject */
export default function Gs2006Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireTemplateSlot: IFormulaireTemplateSlotClass,
    MenuItemMultiOccurrence: IMenuItemMultiOccurrenceClass,
    Menu: IMenuClass,
    exLibelleFilter: IFilterLibelle,
) {

    const vm: IPageGS2006 = this;
    vm.formulaireGs = new Formulaire('', [
        new FormulaireItem('rqtmne', {
            largeur: 33,
            readonly: true
        }),
        new FormulaireItem('rqtnom', {
            largeur: 33,
            readonly: true
        }),
        new FormulaireItem('rqthlp', {
            largeur: 33
        }),
        new FormulaireItem('rqtfrm', {
            largeur: 33
        }),
        new FormulaireItem('rqtwhr', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgmul', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgent', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgfil', {
            largeur: 33
        }),
        new FormulaireItem('t_rqtmne', {
            largeur: 33,
            readonly: true
        }),
        new FormulaireItem('t_rqtnom', {
            largeur: 33,
            readonly: true
        }),
        new FormulaireItem('rqtwhrparfil', {
            largeur: 33
        }),
        new FormulaireItem('rqtwhrparaff', {
            largeur: 33
        }),
        new FormulaireItem('rqtnivaggmin', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgdateff', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgdatdebfin', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgppa', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgunp', {
            largeur: 33
        }),
        new FormulaireItem('rqtflgpec', {
            largeur: 33
        })
    ]);

    vm.rqcMultiOccurrenceOptions = {
        colonnesFixesGauche: [
            { nom: 'rqcnom', largeur: 180 }
        ],
        colonnesVisibles: [
            { nom: 'rqcmnepar', largeur: 180 },
            { nom: 'rqchlp', largeur: 180 },
            { nom: 'rqcsel', largeur: 180 },
            { nom: 'rqcsupali', largeur: 180 },
            { nom: 'rqcali', largeur: 180 },
            { nom: 'rqcflgcleint', largeur: 180 },
            { nom: 'rqcflgusr', largeur: 180 },
            { nom: 'rqcflgfil', largeur: 180 },
            { nom: 'vaerqctypdon', largeur: 180 },
            { nom: 'rqclon', largeur: 180 },
            { nom: 'rqcmsq', largeur: 180 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('rqcnom', {
            largeur: 33
        }),
            new FormulaireItem('rqcmnepar', {
            largeur: 33
        }),
            new FormulaireItem('rqchlp', {
            largeur: 33
        }),
            new FormulaireItem('rqcsel', {
            largeur: 33
        }),
            new FormulaireItem('rqcsupali', {
            largeur: 33
        }),
            new FormulaireItem('rqcali', {
            largeur: 33
        }),
            new FormulaireItem('rqcflgcleint', {
            largeur: 33
        }),
            new FormulaireItem('rqcflgusr', {
            largeur: 33
        }),
            new FormulaireItem('rqcflgfil', {
            largeur: 33
        }),
            new FormulaireItem('vaerqctypdon', {
            largeur: 33
        }),
            new FormulaireItem('rqclon', {
            largeur: 33
        }),
            new FormulaireItem('rqcmsq', {
            largeur: 33
        })
        ])
    };

    vm.rqaMultiOccurrenceOptions = {
        colonnesVisibles: [
            { nom: 'rqanom', largeur: 180 },
            { nom: 'rqahlp', largeur: 180 },
            { nom: 'rqanivagg', largeur: 180 }
        ],
        colonnesCachees: ['rqacleint'],
        actionsRangeeDroite: new Menu([new MenuItemMultiOccurrence("LBL_BLC_DET", (data, occurrence: IMultiOccurrence) => ({
            bloc: "rag",
            cleint: "ragcleint",
            multiOccurrenceParent: occurrence,
            parentId: data.rqacleint,
            fonctions: {
                recherche: false,
                filtrer: false,
                selectionnerDesColonnes: false,
                selectionnerTri: false,
                avisEmploye: false
            },
            colonnesVisibles: [
                { nom: 'ragseq', largeur: 180 },
                { nom: 'rqcnom', largeur: 180 }
            ],
            colonnesCachees: ['ragcleint'],
        }),
            {
                iconButton: true,
                icon: "launch",
                largeur: 50,
                titreDialog: (data, occurrence: IMultiOccurrence) => {
                    return `${exLibelleFilter("Détail", occurrence.libelles)}`
                }
            })])
    };

}
